import React from 'react';
import { Badge } from 'react-bootstrap';

import es from '../../lang/es';
import PaymentActions from './PaymentActions';

const PaymentRow = ({ payment, showState, endFunction, isMobile, isForm }) => {
    //Render
    return (
        isMobile ? (
            <li className="list-group-item">
                <p className='mb-1'>
                    <small>{ es.FIELDS.DATE }</small>
                    <br />
                    <strong>{ payment.created_at }</strong>
                    {
                        showState && !isForm ? (
                            <Badge variant={payment.state.style} className='ml-2'>
                                { payment.state.name }
                            </Badge>
                        ) : null
                    }
                </p>
                <p className='mb-1'>
                    <small>{ es.FIELDS.TYPE }</small>
                    <br />
                    <strong>{ payment.type.name }</strong> <small><strong>{ payment.type.detail }</strong></small>
                </p>
                <p className='mb-1'>
                    <small>{ es.FIELDS.PROCEEDING }:</small>
                    <br />
                    <strong>{ payment.number }</strong> - <small>{ payment.cover }</small>
                </p>
                <p className='mb-1'>
                    <small>{ es.FIELDS.VOUCHER }</small>
                    <br />
                    <strong>{ payment.identificator }</strong>
                </p>
                <p className='mb-0'>
                    <small>{ es.FIELDS.AMOUNT }</small>
                    <br />
                    <small><strong>{ es.PAYMENTS.CURRENCY }</strong></small> <strong>{ payment.amount }</strong>
                </p>
                {
                    !isForm ? (
                        <PaymentActions
                            payment={payment}
                            endFunction={endFunction}
                        />
                    ) : null
                }
            </li>
        ) : (
            <tr>
                <td className="align-middle text-center">
                    { payment.created_at }
                </td>
                <td className="align-middle">
                    <strong>{ payment.number }</strong>
                    <br />
                    <small>{ payment.cover }</small>
                </td>
                <td className="align-middle">
                    <i>{ payment.type.description }</i>
                    <br />
                    <strong>{ payment.identificator }</strong>
                </td>
                <td className="align-middle text-right">
                    { es.PAYMENTS.CURRENCY } <strong>{ payment.amount }</strong>
                    {
                        isForm ? (
                            <input 
                                type="hidden" 
                                name={`Producto[${ payment.id }]`} 
                                value={`${payment.number}: ${payment.type.description}` } 
                            />
                        ) : null
                    }
                </td>
                {
                    showState && !isForm ? (
                        <td className="align-middle text-center">
                            <Badge variant={payment.state.style}>
                                { payment.state.name }
                            </Badge>
                        </td>
                    ) : null
                }
                {
                    !isForm ? (
                        <td className="align-middle text-center">
                            <PaymentActions
                                payment={payment}
                                endFunction={endFunction}
                            />
                        </td>
                    ) : null
                }
            </tr>
        )
    );
};

export default PaymentRow;